<template>
  <div class="acsidebar shadow-lg" v-show="sidebarloaded===true">
    <div class="text-center sidebarpl" v-show="sidebarenabled===false">
      <p><button @click="doUnCollapse" class="btn-transparent"><font-awesome-icon icon="bars" aria-label="Expand Sidebar"></font-awesome-icon></button></p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p><router-link :to="{name: 'groupdash', params: { id: group.LicensePoolGroupID }}"><font-awesome-icon icon="columns" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'groupmembers', params: { id: group.LicensePoolGroupID }}"><font-awesome-icon icon="user-friends" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'groupgroups', params: { id: group.LicensePoolGroupID }}"><font-awesome-icon icon="users" role="presentation"></font-awesome-icon></router-link></p>
      <p v-show="isGroupAdministrator===true"><router-link :to="{name: 'groupprivileges', params: { id: group.LicensePoolGroupID }}"><font-awesome-icon icon="user-lock" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'groupreporting', params: { id: group.LicensePoolGroupID }}"><font-awesome-icon icon="chart-pie" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'grouptags', params: { id: group.LicensePoolGroupID }}"><font-awesome-icon icon="tag" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'groupedit', params: { id: group.LicensePoolGroupID }}" name="edit_menu_m" style="display:none"><font-awesome-icon icon="edit" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'grouplogs', params: { id: group.LicensePoolGroupID }}" name="logs_m" style="display:none"><font-awesome-icon icon="clipboard-list" role="presentation"></font-awesome-icon></router-link></p>
    </div>
    <div v-show="sidebarenabled===true" class="sidebarpl">
      <button @click="doCollapse" class="btn-transparent" style="margin-left:-15%"><font-awesome-icon icon="bars" aria-label="Collapse Sidebar"></font-awesome-icon></button>
      <h3>{{group.LicensePoolGroupName}}</h3>
      <div class="accountstatus" id="account_status">{{acctStatus}}</div>
      <div class="sidebarlinks" v-if="group!==null">
        <p><router-link :to="{name: 'groupdash', params: { id: group.LicensePoolGroupID }}" name="dashboard"><font-awesome-icon icon="columns" role="presentation"></font-awesome-icon> Dashboard</router-link></p>
        <p><router-link :to="{name: 'groupmembers', params: { id: group.LicensePoolGroupID }}" name="members"><font-awesome-icon icon="user-friends" role="presentation"></font-awesome-icon> Members</router-link></p>
        <p><router-link :to="{name: 'groupgroups', params: { id: group.LicensePoolGroupID }}" name="menu_subgroups"><font-awesome-icon icon="users" role="presentation"></font-awesome-icon> Subgroups</router-link></p>
        <p v-show="isGroupAdministrator===true"><router-link :to="{name: 'groupprivileges', params: { id: group.LicensePoolGroupID }}" name="priviledges"><font-awesome-icon icon="user-lock" role="presentation"></font-awesome-icon> Privileges</router-link></p>
        <p><router-link :to="{name: 'groupreporting', params: { id: group.LicensePoolGroupID }}" name="reports_analytics"><font-awesome-icon icon="chart-pie" role="presentation"></font-awesome-icon> Reports/Analytics</router-link></p>       
        <p><router-link :to="{name: 'grouptags', params: { id: group.LicensePoolGroupID }}" name="tags"><font-awesome-icon icon="tag" role="presentation"></font-awesome-icon> Tags</router-link></p>
        <p><router-link :to="{name: 'groupedit', params: { id: group.LicensePoolGroupID }}" name="edit_menu" style="display:none"><font-awesome-icon icon="edit" role="presentation"></font-awesome-icon> Edit</router-link></p>
        <p><router-link :to="{name: 'grouplogs', params: { id: group.LicensePoolGroupID }}" name="logs" style="display:none"><font-awesome-icon icon="clipboard-list" role="presentation"></font-awesome-icon> Logs</router-link></p>
      </div>
      <div class="mt-5" v-if="showPool===true">
        <button class="btn btn-secondary btn-gotopool" @click="goToPool" id="go_to_pool">Go to Pool</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .accountstatus {
    margin-top: 5%;
  }

  .btn-gotopool {
    width: 125px !important;
  }
</style>

<script>
  export default {
    name: 'GroupSidebar',
    data() {
      return {
        acctStatus: "Data Viewer",
        group: {
          LicensePoolGroupName: "Loading",
          LicensePoolGroupID: this.emptyguid
        },
        isGroupAdministrator: false,
        isPoolAdministrator: false,
        showPool: null,
        sidebarenabled: null,
        sidebarloaded: false
      }
    },
    methods: {
      doCollapse() {
        this.sidebarenabled = false;
        this.collapseSidebar();
      },
      doUnCollapse() {
        this.sidebarenabled = true;
        this.deCollapseSidebar();
      },
      goToPool() {
        this.$router.push({ name: 'poolgroups', params: { id: this.group.LicensePoolID } });
      },
      showElements(elementNames) {
        elementNames.forEach(name => {
          const element = document.getElementsByName(name)[0];
          if (element) element.style.display = 'block';
        });
      }
    },
    mounted() {
      this.$bus.$on("GroupSidebarUpdateEvent", (groupstat, ap, showpool, ispooladmin, isenabled) => {
        if (groupstat) {
          this.acctStatus = "Group Administrator";
          this.isGroupAdministrator = true;
        }
        this.isPoolAdministrator = ispooladmin;
        this.showPool = showpool;
        this.group = ap;

        if (typeof (isenabled) !== "undefined" && isenabled === false) {
          this.sidebarenabled = false;
          var self = this;
          window.setTimeout(function () {
            self.collapseSidebar();
            self.sidebarloaded = true;
          }, 100);
        }
        else {
          this.sidebarloaded = true;
          this.sidebarenabled = true;
        }
      });

      debugger;
      window.setTimeout(() => {
        //Below code hides the "Edit" and "Log" menu if user is lifeline
        var udata = JSON.parse(localStorage.getItem("udata"));       
        this.apiCommand([{
          Operation: "LicensePool",
          Function: "isLifelineUser",
          Fields: {
            ClientID: udata.ClientID
          }
        }]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          let flag = JSON.parse(cr.returnObjects[0].returnObject);
          if (flag == "false") {

            // Define the elements to show
            const elementsToShow = [
              "edit_menu", "edit_menu_m", "logs", "logs_m"
            ];
            this.showElements(elementsToShow);
          }         
        });
      }, 1000);

      setTimeout("Window.loadLanguageContent()", 500);
    },
    computed: {
      isDisabled() {
        if (sessionStorage.getItem("isSimmersionUser")) {
          return true;
        }
        else {
          return false;
        }
      }

    }
  }
</script>
